export default __webpack_public_path__ + "static/media/user-placeholder.174cd90b.png";